import { CrudState } from "@/store/Crud/State";
import { IBalanceOverview } from "@/interfaces/IBalanceOverview";

export class State extends CrudState {
  balanceOverview: IBalanceOverview = {};
}
